import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import { useNavigate } from 'react-router-dom'
import {
  ONGOING_DDEX,
  ONGOING_DDEX_VISIBLE,
} from '@disco/constants/FeatureTypes'
import { useFeatureData } from '@disco/state-management/selectors/business'
import DDEXSettings from './DDEXSettings'
import type { PrivateMetadata } from 'types/business'

const DDEXSettingsContainer = (): React.ReactNode => {
  const navigate = useNavigate()
  const { isFeatureEnabled, isTrial } = useFeatureData(ONGOING_DDEX)
  const { isFeatureEnabled: isPageVisible } =
    useFeatureData(ONGOING_DDEX_VISIBLE)
  const { ddex_distributor } = useSelector(state => {
    return state.user.business?.private_metadata || ({} as PrivateMetadata)
  })
  useEffect(() => {
    if (!isFeatureEnabled && !isPageVisible) {
      navigate('/settings', { replace: true })
    }
  }, [isFeatureEnabled, isPageVisible, navigate])
  return (
    <DDEXSettings
      isFeatureEnabled={isFeatureEnabled}
      isTrial={isTrial}
      ddex_distributor={ddex_distributor}
    />
  )
}

export default DDEXSettingsContainer
